<template>
  <div id="project-overview" class="mx-10 mb-10">
    <TimeFrameButtons
      :title="'Projects Overview'"
      :time-frames="['week', 'month', 'year']"
      :active-time-frame="activePeriod"
      @change-time-frame="filterData"
    />
    <v-row>
      <v-col
        xs="12"
        sm="12"
        md="12"
        lg="6"
        xl="3"
        v-for="(value, index) in statics.linearProgress.length > 0
          ? statics.linearProgress
          : placeholders"
        :key="index"
      >
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="pa-5"
            @click="navigateToProjectList(getTitles(index))"
            :style="{
              border: '1px solid var(--primary-boarder-color)',
              borderBlockEndColor: getStatusColors(getTitles(index)).text,
              borderBlockEndWidth: hover ? '3px' : '1px',
              marginBlockEnd: hover ? '-2px' : '',
            }"
          >
            <v-card-text>
              <div class="d-flex align-center gap-x-4 mb-2">
                <v-avatar
                  :color="getStatusColors(getTitles(index)).chip"
                  size="50"
                  class="rounded-lg"
                  variant="tonal"
                >
                  <v-icon
                    size="x-large"
                    :color="getStatusColors(getTitles(index)).text"
                    >{{ getIconForIndex(index) }}</v-icon
                  >
                </v-avatar>
                <h4 class="text-h4 mx-5">{{ statics.count[index] || 0 }}</h4>
              </div>
              <h6 class="text-h6 font-weight-regular">
                {{ getTitles(index) }}
              </h6>
              <div class="d-flex align-center">
                <div class="text-body-1 font-weight-medium me-2">
                  {{ value || 0 }}%
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-progress-linear
                :value="value || 0"
                :color="getStatusColors(getTitles(index)).text"
                height="5"
                class="progress-liner"
              ></v-progress-linear>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TimeFrameButtons from "@/components/dashboard/TimeFrameButtons.vue";
import { ProjectService } from "@/services/project-service.js";
import { getStatusColors } from "@/utility/statusColors.js";

export default {
  name: "ProjectOverview",
  components: {
    TimeFrameButtons,
  },

  data() {
    return {
      activePeriod: "week",
      statics: {
        linearProgress: [],
        count: [],
      },
      loading: false,
      placeholders: Array(4).fill(0),
    };
  },
  mounted() {
    this.filterData(this.activePeriod);
  },
  methods: {
    filterData(timeFrame) {
      this.activePeriod = timeFrame;
      this.filter = timeFrame;
      this.getProjectOverview();
    },
    getTitles(index) {
      const titles = ["PENDING", "IN-PROGRESS", "HOLD", "COMPLETED"];
      return titles[index];
    },
    getIconForIndex(index) {
      const icons = [
        "mdi-timelapse",
        "mdi-progress-check",
        "mdi-pause",
        "mdi-check",
      ];
      return icons[index];
    },
    getProjectOverview() {
      this.loading = true;
      ProjectService.getProjectsOverview(this.filter)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.statics = response.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          this.errors = data;
        });
    },
    navigateToProjectList(status) {
      this.$router.push({ name: "ProjectsList", query: { status } });
    },
    getStatusColors(status) {
      return getStatusColors(status);
    },
  },
};
</script>
